import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-communication-view-dialog',
  templateUrl: './communication-view-dialog.component.html',
  styleUrls: ['./communication-view-dialog.component.scss']
})
export class CommunicationViewDialogComponent implements OnInit {
  // Plain string bound via [innerHTML] WITHOUT bypassing the sanitizer, so Angular's
  // DomSanitizer strips scripts and event handlers (e.g. <img onerror>) while keeping
  // safe formatting (<br>, <b>, <p>, <a href>...). Fixes stored XSS (F-016).
  processedContent: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { communication: any }
  ) { }

  ngOnInit(): void {
    this.processContent();
  }

  private processContent(): void {
    if (!this.data.communication.content) {
      this.processedContent = '';
      return;
    }

    // Decode stored HTML entities and normalize line breaks for display.
    // Order matters: process &amp; last to avoid double-decoding nested entities.
    // NOTE: the result is intentionally NOT wrapped in bypassSecurityTrustHtml — it is
    // assigned as a plain string so Angular sanitizes it on the [innerHTML] binding.
    const processed = this.data.communication.content
      .replace(/&nbsp;/g, ' ')  // Replace &nbsp; with regular spaces
      .replace(/&lt;/g, '<')    // Replace &lt; with <
      .replace(/&gt;/g, '>')    // Replace &gt; with >
      .replace(/&quot;/g, '"')  // Replace &quot; with "
      .replace(/&#39;/g, "'")   // Replace &#39; with '
      .replace(/&amp;/g, '&')   // Replace &amp; with & (do this last to handle nested entities)
      .replace(/\n/g, '<br>')   // Convert newlines to <br> tags
      // Fix bullet points: remove line breaks immediately after bullet points
      .replace(/•\s*(<br\s*\/?>)+/gi, '• ')
      // Condense multiple <br> tags (with optional whitespace) to max 2
      .replace(/(<br\s*\/?>)(\s*<br\s*\/?>){2,}/gi, '<br><br>');

    // Angular sanitizes this string on the [innerHTML] binding (no SafeHtml bypass).
    this.processedContent = processed;
  }
}
